import './contact.css';
import React, { useContext, useEffect, useState } from 'react';
import { Cookies, useCookies } from 'react-cookie';
import {Table, Nav, Navbar, NavDropdown} from 'react-bootstrap';
import Logo from '../Images/logo.png';
import { LoadingSign } from "../Utility/loading-sign";
import { fetchGetContacts } from '../API/apiservice';

export const Contact = (props) => {
    const cookies = new Cookies();
    // const [setCookie, removeCookie] = useCookies(['user']);
    const [data, setData] = useState();
    const [isLoading, setIsLoading] = useState(false);
    // const [contactEmaiList, setContactEmailList] = useState([]);
    const [contactEmaiList, setContactEmailList] = useState(JSON.parse(localStorage.getItem('contactEmailList')));
    const [isApiError, setIsApiError] = useState(false);

    useEffect(() => {     
        // setIsLoading(true);
        // if(cookies.get('email'))
        // {
        //         const getData = async () => {
        //             const data = await fetchGetContacts(cookies.get('email'), cookies.get('warehouse'));
        //             if(Array.isArray(data) && data[0] == 'error')
        //             {
        //                 setIsApiError(true);
        //             }
        //             else {
        //                 // console.log(data);
        //                 let temp = {};
        //                 let tempList= [];
        //                 for(let i = 0; i < data.contactEmail.length; i++)
        //                 {
        //                     temp = {customerNumber: data.contactEmail[i].custNum, storeName: data.contactEmail[i].name, email: data.contactEmail[i].rmEmail};
        //                     tempList.push(temp);
        //                 }
        //                 setContactEmailList(tempList);
        //                 console.log(tempList);
        //             //   if(data.success)
        //             //   {
      
        //             //   }
        //             //   else if(data.error)
        //             //   {
        //             //     setErrorMsg(data.error);
        //             //   }
        //             }
        //             setIsLoading(false);
        //           };
        //           let timer;
        //           const debounceGetData = () => {
        //               if (timer) {
        //                   clearTimeout(timer);
        //               }
        //               timer = setTimeout(getData, 500);
        //           };
          
        //           debounceGetData();
          
        //           return () => {
        //               clearTimeout(timer);
        //           };            
        // }
      }, []
      )

      const renderContactList = () => {
        return contactEmaiList.map((row, index) => (
            <tr key={index}>
                {row.custNum ? 
                    // <td>{row.customerNumber} - {row.storeName}: <a href={`mailto:${row.email}`}>{row.email}</a></td>
                    <>
                    <td style={{ width: "5%" }}>{row.custNum}</td>
                    <td>{row.name}</td>
                    <td> <a href={`mailto:${row.rmEmail}`}>{row.rmEmail}</a></td>
                    </>
                    : 
                    <td colSpan={3}><a href={`mailto:${row.rmEmail}`}>{row.rmEmail}</a></td>
                }
                {/* <td><a href={`mailto:${row.email}`}>{row.email}</a></td> */}
                {/* <td>{row.invoiceNum}</td>
                <td>{formatDate(row.invoiceDate)}</td>
                <td>{formatDate(row.dueDate)}</td>
                <td>{toCurrency(Math.abs(row.invoiceAmount))}</td> */}
            </tr>
        ));
    };

    return (
        <div className="contactContainer">
            <LoadingSign isLoading={isLoading} />
            <img className="logo" src={Logo} alt="Logo" />
            <h5>"Helping people grow beautiful & healthy gardens-organically"</h5>
            <p>Phone 310.830.2200, Fax 310.835.6174, Web www.KelloggGarden.com</p>
            <Table className="contactTable">
                <thead>
                    <tr>
                        <th colSpan={3}><h3>Contact Us</h3></th>
                    </tr>
                </thead>
                <tbody className="alignLeft">
                    <tr>
                        <td colSpan={3}>We're here to help! Please choose from options below and include your customer ID number in correspondence.</td>
                    </tr>
                    <tr>
                        <td className="bold" colSpan={3}>TERRITORY MANAGER</td>
                    </tr>
                    {!isApiError ? 

                        (contactEmaiList.length > 1) ?
                            <Table striped bordered hover className="contactList"><tbody>{renderContactList()}</tbody></Table>
                            // renderContactList()
                                :
                            renderContactList()
                        :
                        <tr>
                            <td colSpan={3}>*There was an error getting the data. Please try again.</td>
                        </tr>
                    }
                    <tr>
                        {/* <td><a href={`mailto:${cookies.get('contactEmail')}`}>{cookies.get('contactEmail')}</a></td> */}
                    </tr>
                    <tr>
                        <td className="bold" colSpan={3}>AR SPECIALIST</td>
                    </tr>
                    <tr>
                        <td colSpan={3}><a href="mailto:AR@KelloggGarden.com">AR@KelloggGarden.com</a></td>
                    </tr>
                    <tr>
                        <td className="bold" colSpan={3}>I.T. SUPPORT</td>
                    </tr>
                    <tr>
                        <td colSpan={3}><a href="mailto:ITemail">support@kgpsupport.atlassian.net</a></td>
                    </tr>
                    <tr>
                        <td className="bold" colSpan={3}>CORPORATE OFFICE:</td>
                    </tr>
                    <tr>
                        <td colSpan={3}>
                            Phone: 310.830.2200 <br/>
                            Fax:  310.835.6174<br/><br/>
                            350 W. Sepulveda Blvd. <br/>
                            Carson, CA  90745</td>
                    </tr>
                    <tr>
                        <td className="bold" colSpan={3}>CHECK REMITTANCE:</td>
                    </tr>
                    <tr>
                        <td colSpan={3}>P.O. Box 516514 <br/> Los Angeles, CA  90051-7801</td>
                    </tr>
                </tbody>
            </Table>
        </div>
    );
};